<template>
  <b-navbar type="dark">
    <a href="" @click="$router.push('/')">
      <img src="../assets/Apop_Logo_xsm.png" alt="small logo"/>
    </a>
    <ApopUserMenu/>
  </b-navbar>
</template>

<script>
  import ApopUserMenu from '../components/ApopUserMenu'

  export default {
    name: 'ApopBar',
    components: {
      ApopUserMenu
    }
  }
</script>
